export const BUTTON_TOKEN_API_URL = "https://andrada-dev-api-c0ftceguhvg8hzdd.westeurope-01.azurewebsites.net/api/button/token";
export const TAB_HOST_URL = "https://preprodgo.accessacloud.com";
export const BASE_URL = window.location.origin;


function detectEnvironment() {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local';
  }
  
  if (hostname.includes('preprod') || hostname.includes('az-preprod') || hostname.includes('westeurope-01')) {
    return 'preprod';
  }
  
  return 'production';
}

function getPlatformUrl() {
  const environment = detectEnvironment();
  
  switch (environment) {
    case 'local':
      return 'http://localhost:4792';
    case 'preprod':
          return 'https://preprodgo.accessacloud.com';
    case 'production':
    default:
      return 'https://go.accessacloud.com';
  }
}

function getApiBaseUrl() {
    const environment = detectEnvironment();
    switch (environment) {
        case 'local':
            return 'https://localhost:7227/';
        case 'preprod':
        case 'production':
        default:
            return 'https://andrada-dev-api-c0ftceguhvg8hzdd.westeurope-01.azurewebsites.net/';
    }
}

function getApplicationBaseUrl() {
    const environment = detectEnvironment();

    switch (environment) {
        case 'local':
            return 'http://localhost:3000';
        case 'preprod':
            return TAB_HOST_URL;
        case 'production':
        default:
            return TAB_HOST_URL;
    }
}

export const BASE_API_URL = getApiBaseUrl();
export const PLATFORM_URL = getPlatformUrl();
export const APPLICATION_BASE_URL = getApplicationBaseUrl();
